<template>
    <div class="user">
        <!--搜索表单-->
        <div class="common-seach-wrap"> </div>
        <div class="goods-content">
            <el-form ref="form" :model="form" label-width="100px">
                <div class="table-wrap">
                    <el-table v-loading="loading" size="small" :data="tableData" border style="width: 100%">
                        <el-table-column prop="title" label="活动名称"></el-table-column>
                        <el-table-column prop="join_end_time_text" label="报名截止日期" width="150"></el-table-column>
                        <el-table-column prop="start_time_text" label="开始日期" width="150"></el-table-column>
                        <el-table-column prop="end_time_text" label="结束时间" width="150"></el-table-column>
                        <el-table-column prop="status_text" label="活动状态" width="120"></el-table-column>
                        <el-table-column prop="create_time" label="创建时间" width="150"></el-table-column>
                        <el-table-column fixed="right" label="操作" width="90">
                            <template slot-scope="scope">
                                <el-button v-if="scope.row.join_status == 1" type="text" size="small" @click="openGoods(scope.row)">报名</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </el-form>
            <!--分页-->
            <div class="pagination">
                <el-pagination
                    background
                    :current-page="curPage"
                    :page-size="pageSize"
                    layout="total, prev, pager, next, jumper"
                    :total="totalDataNumber"
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                >
                </el-pagination>
            </div>
        </div>
        <!--商品选择-->
        <Goods :isgoods="isgoods" :exclude-ids="exclude_ids" :islist="false" @closeDialog="closeGoodsFunc"></Goods>
    </div>
</template>
<script>
    import Goods from "@/components/goods/Goods.vue";
    import SeckillApi from "@/api/seckill";
    export default {
        components: {
            /*选择商品*/
            Goods
        },
        data() {
            return {
                formInline: {},
                form: {},
                tableData: [],
                /*一页多少条*/
                pageSize: 20,
                /*一共多少条数据*/
                totalDataNumber: 0,
                /*当前是第几页*/
                curPage: 1,
                /*是否加载完成*/
                loading: true,
                /*是否打开选择商品*/
                isgoods: false,
                /*已有的id*/
                exclude_ids: [],
                seckill_activity_id: 0
            };
        },
        created() {
            /*获取列表*/
            this.getData();
        },
        methods: {
            /*获取列表*/
            getData() {
                let self = this;
                let Params = {};
                Params.page = self.curPage;
                Params.list_rows = self.pageSize;
                SeckillApi.activeList(Params, true)
                    .then((data) => {
                        self.loading = false;
                        self.tableData = data.data.list.data;
                        self.totalDataNumber = data.data.list.total;
                        self.exclude_ids = data.data.exclude_ids;
                    })
                    .catch((error) => {});
            },
            /*选择第几页*/
            handleCurrentChange(val) {
                let self = this;
                self.curPage = val;
                self.loading = true;
                self.getData();
            },

            /*每页多少条*/
            handleSizeChange(val) {
                this.curPage = 1;
                this.pageSize = val;
                this.getTableList();
            },
            /*打开添加*/
            openGoods(row) {
                this.seckill_activity_id = row.seckill_activity_id;
                this.isgoods = true;
            },

            /*关闭商品选择*/
            closeGoodsFunc(e) {
                this.isgoods = false;
                if (e.type == "success") {
                    this.$router.push("/activity/seckill/add?goods_id=" + e.params.goods_id + "&seckill_activity_id=" + this.seckill_activity_id);
                }
            }
        }
    };
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/activity/seckill/list.vue